// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import global from '@/common/global'
import { applyRouteSeo } from '@/common/seo'
import '../static/assets/css/style.css'
Vue.config.productionTip = false
Vue.prototype.global = global
global.init();

router.afterEach(function(to) {
  applyRouteSeo(to)
})

router.onReady(function() {
  applyRouteSeo(router.currentRoute)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js